document.querySelectorAll('.header-slider-section').forEach(section => {
    const slider = section.querySelector('.header-slider-section-inner');
    const position = section.querySelector('.header-slider-section-position');
    const slides = slider.querySelectorAll('.header-slider-section-slide');
    const nav = document.createElement('nav');
    nav.classList.add('header-slider-section-nav');
    const navInner = document.createElement('div');
    navInner.classList.add('header-slider-section-nav-inner');
    nav.appendChild(navInner);
    const dots = [];

    if(slides.length > 1){
        slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.classList.add('header-slider-section-nav-dot');
            dot.dataset.index = index;
            slide.dataset.index = index;
            dot.addEventListener('click', e => {
                e.preventDefault();
                slider.scrollTo({
                    left: slide.offsetLeft,
                    behavior: 'smooth'
                });
            });
            navInner.appendChild(dot);
            dots.push(dot);
        });
        position.appendChild(nav);
    }

    const update = () => {
        const slide = Array.from(slides).find(slide => {
            const rect = slide.getBoundingClientRect();
            return rect.left >= -100 && rect.right <= window.innerWidth + 100;
        });
        if(!slide) return;

        dots.forEach(dot => {
            dot.classList.toggle('header-slider-section-nav-dot-active', dot.dataset.index === slide.dataset.index);
        });
    };

    slider.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
});